import { z } from "zod";
import { ACTION_PRIORITIES, ACTION_STATUSES } from "@/shared/pulse/actions/action-vocabulary";

/// URL-state for the My-actions list filters (S3, filters in the URL so
/// refresh / share / back all work).
export const myActionsSearchSchema = z
  .object({
    status: z.enum(ACTION_STATUSES).optional(),
    priority: z.enum(ACTION_PRIORITIES).optional(),
  })
  .strict();

export type MyActionsSearch = z.infer<typeof myActionsSearchSchema>;
